// extracted by mini-css-extract-plugin
export default {"ConfirmationStatement":"ConfirmationStatement_ConfirmationStatement"};